export default {
  'Contact': '/info/contact',
  'Profil': '/info/profil',
  'Equipe': '/info/equipe',
  'Jobs': '/info/jobs',
  'Publications': '/info/publications',
  'Social media': '/info/social',
};
